import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'

import { FiArrowUp } from 'react-icons/fi'

export default function ScrollToTop() {
    let[scroll,setScroll] = useState<boolean>(false)

    const scrollToTop = () =>{
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    useEffect(()=>{

        const handlerScroll=()=>{
            if(window.scrollY > 50){
                setScroll(true)
            }else{setScroll(false)}
        }
        window.addEventListener('scroll',handlerScroll)

        return () => {
            window.removeEventListener('scroll',handlerScroll)
          };
    },[])

  return (
    <button 
        onClick={scrollToTop} 
        className={`fixed bottom-6 right-6 z-[999] w-12 h-12 flex items-center justify-center bg-[#05144b] text-white rounded-full shadow-2xl transition-all duration-300 hover:bg-blue-900 hover:-translate-y-1 active:scale-90 ${scroll ? 'opacity-100 scale-100 visible' : 'opacity-0 scale-50 invisible'}`}
        title="Back to top"
    >
        <FiArrowUp size={24} />
    </button>
  )
}
